export default {
    product:{
        name:'Storefront',
        version:'1.1.0 p-2'
    }
}